import { render } from "./MappaSpostamenti.vue?vue&type=template&id=de30aba6&scoped=true"
import script from "./MappaSpostamenti.vue?vue&type=script&lang=js"
export * from "./MappaSpostamenti.vue?vue&type=script&lang=js"

import "./MappaSpostamenti.vue?vue&type=style&index=0&id=de30aba6&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de30aba6"]])

export default __exports__